// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1091":"9ebe7615","3140":"f4f55507","4726":"f608559a","9092":"758a1c87"}[chunkId] + ".chunk.css";
};